export default {
      id: "cookies-usage",
      viewBox: "0 0 33 35",
      url: __webpack_public_path__ + "img/icons.svg#cookies",
      toString: function () {
        return this.url;
      }
    }